// Importando o React
import React from "react";
// Importando os components necessários da lib react-materialize
import { Row, Col, Card } from 'react-materialize';

import logo27anos from '../../images/tocuidando_27anos.jpeg';

const Home = () => (
  <Row >
  
        
       
      <div className={"containerlogo"}> 
          <img src={logo27anos} className={"bg"} alt="Tô Cuidando - 27 anos" />
         
        </div>
        
   
  </Row>
);

export default Home;
